import { render, staticRenderFns } from "./FwdCkuTest.vue?vue&type=template&id=3443b798&"
import script from "./FwdCkuTest.vue?vue&type=script&lang=js&"
export * from "./FwdCkuTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports